import axios, { AxiosResponse } from 'axios';
import { getInGameBalanceEndpoint } from '@/api/helpers/get-in-game-balance-endpoint';
import { InGameBalanceRequest, InGameBalanceResponse } from './types';
import { getFabricAuthToken } from '@/utilities/axios/api-axios';

const IN_GAME_BALANCE_TIMEOUT_MS = 5000;

export const getInGameBalance = async ({
  providerName,
  rgsCode,
  userId,
}: Omit<
  InGameBalanceRequest,
  'requestId'
>): Promise<AxiosResponse<InGameBalanceResponse> | null> => {
  const endpoint = getInGameBalanceEndpoint();

  if (!userId || !endpoint) {
    return null;
  }

  const authToken = await getFabricAuthToken('IN_GAME_BALANCE');

  const instance = axios.create();
  const requestId = crypto.randomUUID().toString();
  const body = { requestId, providerName, rgsCode, userId: Number(userId) };

  const response = await instance.post<InGameBalanceResponse>(endpoint, body, {
    headers: {
      'x-auth-token': authToken,
      'Content-Type': 'application/json',
    },
    timeout: IN_GAME_BALANCE_TIMEOUT_MS,
  });

  return response;
};
